/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type FeedBackTypeEnum = 0 | 1 | 2;

export const FeedBackTypeEnum = {
    NUMBER_0: 0 as FeedBackTypeEnum,
    NUMBER_1: 1 as FeedBackTypeEnum,
    NUMBER_2: 2 as FeedBackTypeEnum
};
